import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function CheckmarkCircleFill({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M2.1001 12C2.1001 6.53236 6.53248 2.09998 12.0001 2.09998C17.4677 2.09998 21.9001 6.53236 21.9001 12C21.9001 17.4676 17.4677 21.9 12.0001 21.9C6.53248 21.9 2.1001 17.4676 2.1001 12ZM16.1222 10.2394C16.4737 9.88795 16.4737 9.3181 16.1222 8.96663C15.7708 8.61516 15.2009 8.61516 14.8495 8.96663L10.5968 13.2192L9.08024 11.7026C8.72877 11.3512 8.15892 11.3512 7.80745 11.7026C7.45598 12.0541 7.45598 12.624 7.80745 12.9754L9.96045 15.1284L9.97445 15.1424C10.3259 15.4939 10.8958 15.4939 11.2472 15.1424C11.293 15.0967 11.3328 15.0472 11.3666 14.995L16.1222 10.2394Z" fill="currentColor" /></Svg>;
}
export default CheckmarkCircleFill;